import { createContext, useContext, useMemo, useState } from "react";
import { UI } from "../lib/i18n";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("fichaje_carta_lang") || "va");

  const setLang = (l) => {
    localStorage.setItem("fichaje_carta_lang", l);
    setLangState(l);
  };

  const t = (key) => (UI[lang] && UI[lang][key]) || UI.va[key] || key;

  const value = useMemo(() => ({ lang, setLang, t }), [lang]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
